import { useQueryClient } from '@tanstack/react-query';

import type { Folder } from '../../types/folder.types';
import { invalidateFolderRelated } from '../folderCache';

/**
 * 폴더를 바꾼 뒤 관련 조회를 맞춘다.
 *
 * ⚠️ 뮤테이션 응답으로 상세 캐시를 덮어쓰지 않는다. 응답의 `items` 는 미리보기 4개라
 * 그대로 써넣으면 상세 목록이 4개로 잘린다. 대신 무효화한다.
 */
export const useSyncFolder = () => {
  const queryClient = useQueryClient();
  return (folder: Folder) => invalidateFolderRelated(queryClient, folder.id);
};
